import cx from "classnames"
import { camelize } from "../../utils"
import type { IconColorsType } from "../"
export type IconProps = {
  color?: IconColorsType
  size?: 16 | 20 | 24 | 32
  contained?: boolean
  className?: string
}
const iconSource = "utilityVanLarge"
const UtilityVanLargeIcon = ({
  color,
  size = 24,
  contained = false,
  className,
}: IconProps) => {
  const computedClassName = cx(
    className,
    `cobalt-Icon cobalt-Icon--${iconSource}`,
    {
      [`c-fill-${camelize(color || "")}`]: color,
      "cobalt-Icon--size16": size === 16,
      "cobalt-Icon--size20": size === 20,
      "cobalt-Icon--size32": size === 32,
      "cobalt-Icon--contained": contained,
    },
  )
  return (
    <span className={computedClassName}>
      {
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
          <title>{iconSource}</title>
          <path
            fillRule="evenodd"
            d="M14.813 6.938H16.984C17.827 6.938 18.586 7.45 18.9 8.234L19.942 10.842 21.587 11.665C22.03 11.887 22.313 12.342 22.313 12.839V16.125C22.313 16.85 21.725 17.438 21 17.438H19.898C19.444 18.222 18.596 18.75 17.625 18.75S15.806 18.222 15.352 17.438H8.648C8.194 18.222 7.346 18.75 6.375 18.75S4.556 18.222 4.102 17.438H3C2.275 17.438 1.688 16.85 1.688 16.125V5.25C1.688 4.525 2.274 3.938 3 3.938H14.813zM6.374 15C5.754 15 5.25 15.504 5.25 16.125S5.754 17.25 6.375 17.25 7.5 16.746 7.5 16.125 6.996 15 6.375 15M17.625 15C17.004 15 16.5 15.504 16.5 16.125S17.004 17.25 17.625 17.25 18.75 16.746 18.75 16.125 18.246 15 17.625 15M14.813 16.313H15.008Q15.001 16.22 15 16.125C15 14.675 16.175 13.5 17.625 13.5S20.25 14.675 20.25 16.125Q20.249 16.219 20.242 16.313H21C21.104 16.313 21.188 16.229 21.188 16.125V14.438H21C20.69 14.438 20.438 14.186 20.438 13.875S20.689 13.313 21 13.313H21.188V12.839C21.188 12.768 21.147 12.703 21.084 12.67L19.367 11.813H14.812zM3 5.063C2.896 5.063 2.813 5.146 2.813 5.25V11.438H3C3.31 11.438 3.563 11.689 3.563 12 3.563 12.31 3.31 12.563 3 12.563H2.813V13.313H3C3.31 13.313 3.563 13.564 3.563 13.875 3.563 14.185 3.31 14.438 3 14.438H2.813V16.125C2.813 16.229 2.896 16.313 3 16.313H3.758Q3.751 16.22 3.75 16.125C3.75 14.675 4.925 13.5 6.375 13.5S9 14.675 9 16.125Q8.999 16.219 8.992 16.313H13.687V5.063zM14.813 10.688H18.669L17.855 8.652C17.713 8.296 17.367 8.062 16.985 8.062H14.812z"
            clipRule="evenodd"
          />
        </svg>
      }
    </span>
  )
}
export default UtilityVanLargeIcon
